import React from "react";

const ContainerWrapper = (Component) => 
   function HOC(){
       const style = {
           "width": "100vw",
           "height" : "100vh",
           "display": 'flex',
           "alignItem": "center",
           "justifyContent": "center"
       }
   
       return (
           <div style={style}>
               <Component />
           </div>
       )
   }


export default ContainerWrapper;